import { isValidJsonStr } from 'shared/helpers';


class ObjStore {
  constructor(adaptor) {
    this.adaptor = adaptor;
  }

  get() {
    return this.adaptor.get();
  }

  set(obj) {
    return this.adaptor.set(obj);
  }

  remove() {
    return this.adaptor.remove();
  }
}


export const makeLocalObjStore = (TOP_LEVEL_KEY) => {

  const webAdaptor = {
    get() {
      const val = window.localStorage.getItem(TOP_LEVEL_KEY);

      // Something's fucky, shouldn't happen, just throw it out.
      if (!isValidJsonStr(val)) {
        this.remove();
        return null;
      }

      return JSON.parse(val);
    },

    set(obj) {
      const val = JSON.stringify(obj);
      return window.localStorage.setItem(TOP_LEVEL_KEY, val);
    },

    remove() {
      return window.localStorage.removeItem(TOP_LEVEL_KEY);
    },
  };

  return new ObjStore(webAdaptor);
};



// WEBPACK FOOTER //
// ./src/shared/helpers/localObjStoreFactory.js